import { render, staticRenderFns } from "./ImportacaoBemBtn.vue?vue&type=template&id=f33c9eb6&"
import script from "./ImportacaoBemBtn.vue?vue&type=script&lang=js&"
export * from "./ImportacaoBemBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports